var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { useStateWithMutators } from '@rad/hooks';
import { IMAGE_PARTSTECH_LOGO } from '../../../utility/constants';
import { requireToken } from '../../../utility/general';
import { postObjectJson } from '../../../utility/request';
import { getConnectorPartsTech } from '../../../http/connectors';
import Card from '../../components/card';
import Button from '../../components/button';
import CLoading from '../../components/loading';
import CSeparator from '../../components/separator';
import CInput from '../../components/input';
import CSwitch from '../../components/switch';
import CModalConfirm from '../../components/modal.confirm';
import styles from '../../scss/modules/components/button.icon.module.scss';
export default (props) => {
    const token = requireToken('merchant');
    const [state, mutators] = useStateWithMutators({
        'partsTech': undefined,
        'errors': null,
        'loading': {
            'delete': false,
            'update': false,
            'register': false,
            'pricing': false,
        },
        'confirming': {
            'delete': false,
        },
        'form': {
            'username': '',
            'api_key': '',
            'use_retail': false,
        },
    });
    const partstechLoad = () => __awaiter(void 0, void 0, void 0, function* () {
        mutators.partsTech(undefined);
        const value = yield getConnectorPartsTech(token.merchant.id);
        mutators.partsTech(value);
        mutators.errors(null);
        if (value) {
            mutators.form.username(value.username);
            mutators.form.api_key(value.api_key);
            mutators.form.use_retail(value.pricing === 'retail');
        }
        else {
            mutators.form.username('');
            mutators.form.api_key('');
            mutators.form.use_retail(false);
        }
    });
    const partstechSave = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            mutators.loading.update(true);
            mutators.errors(null);
            yield postObjectJson(`/parts-tech/config/${token.merchant.id}`, {
                'username': state.form.username,
                'api_key': state.form.api_key,
            }, {
                'success': () => __awaiter(void 0, void 0, void 0, function* () {
                    yield partstechLoad();
                }),
                'error': (res) => __awaiter(void 0, void 0, void 0, function* () {
                    const es = yield res.json();
                    mutators.errors(Object.fromEntries(es.map((x) => [x.field, x.message])));
                }),
            });
        }
        finally {
            mutators.loading.update(false);
        }
    });
    const partstechRegister = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            mutators.loading.register(true);
            const result = yield postObjectJson(`/parts-tech/config-register/${token.merchant.id}`, {});
            const el = document.createElement('a');
            el.href = result.url || 'https://www.partstech.com/signup';
            el.target = '_blank';
            el.click();
        }
        catch (_a) {
            const el = document.createElement('a');
            el.href = 'https://www.partstech.com/signup';
            el.target = '_blank';
            el.click();
        }
        finally {
            mutators.loading.register(false);
        }
    });
    const partstechDelete = (f) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            mutators.loading.delete(true);
            yield postObjectJson(`/parts-tech/delete/${token.merchant.id}`, {});
            mutators.confirming.delete(false);
            yield partstechLoad();
        }
        finally {
            mutators.loading.delete(false);
            f();
        }
    });
    const partstechPricing = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            mutators.loading.pricing(true);
            yield postObjectJson(`/parts-tech/pricing/${token.merchant.id}`, {
                'pricing': state.form.use_retail ? 'retail' : 'list',
            });
        }
        finally {
            mutators.loading.pricing(false);
        }
    });
    React.useEffect(() => {
        partstechLoad();
    }, []);
    return _jsxs(_Fragment, { children: [_jsx(CModalConfirm, { title: "Disconnect Account", action: "Disconnect", visible: state.confirming.delete, onClose: () => mutators.confirming.delete(false), onSubmit: (f) => partstechDelete(f), children: "Are you sure you want to disconnect? This clears the stored session." }), _jsx(Card, { title: _jsx("a", { href: "https://partstech.com/", children: _jsx("img", { src: IMAGE_PARTSTECH_LOGO, style: { 'height': '20px', 'margin': '-3px 3px 0' } }) }), children: _jsx(CLoading, { dependency: state.partsTech, children: (partsTech) => {
                        var _a, _b;
                        return partsTech === null ? _jsxs(_Fragment, { children: [_jsx("a", { target: "_blank", href: "https://www.partstech.com/signup", className: `${styles.button} ${styles.primary} w-100 mb-2 ${state.loading.register ? 'disabled' : ''}`, onClick: (e) => { e.preventDefault(); partstechRegister(); }, children: state.loading.register ? 'Loading...' : 'Create or Connect an Account' }), _jsx(CSeparator, { children: "OR" }), _jsxs("h6", { className: "position-relative", children: ["Connect an Account Manually", _jsx("a", { target: "_blank", href: "https://partstech.my.site.com/help/s/article/How-do-I-find-my-API-Key", title: "Where to find this information", children: _jsx("i", { className: "material-symbols-outlined text-primary position-absolute end-0", children: "help" }) })] }), _jsxs("form", { onSubmit: (e) => { e.preventDefault(); partstechSave(); }, children: [_jsx(CInput, { type: "text", value: state.form.username, onChange: mutators.form.username, error: (_a = state.errors) === null || _a === void 0 ? void 0 : _a.username, children: "Username" }), _jsx(CInput, { type: "text", value: state.form.api_key, onChange: mutators.form.api_key, error: (_b = state.errors) === null || _b === void 0 ? void 0 : _b.api_key, children: "API Key" }), _jsx("div", { className: "text-end", children: _jsx(Button, { submit: true, color: "primary", disabled: state.loading.update, children: state.loading.update ? 'Saving...' : 'Save' }) })] })] }) : _jsxs(_Fragment, { children: [_jsx(Button, { color: "danger", w100: true, mb: 2, onClick: () => mutators.confirming.delete(true), disabled: state.loading.delete, children: "Disconnect Account" }), _jsx("h6", { children: "Pricing Matrix" }), _jsxs("div", { className: "px-3", children: [_jsx("p", { className: "mb-2", children: "Choose list or retail pricing for PartsTech items on estimates." }), _jsxs("div", { className: "d-flex justify-content-center align-items-center", children: [_jsx(CSwitch, { value: state.form.use_retail, onChange: mutators.form.use_retail, slotChecked: _jsxs(_Fragment, { children: ["Use ", _jsx("strong", { children: "Retail" }), " Pricing"] }), slotUnchecked: _jsxs(_Fragment, { children: ["Use ", _jsx("strong", { children: "List" }), " Pricing"] }), disabled: state.loading.pricing }), _jsx(Button, { color: "primary", ms: 1, onClick: partstechPricing, disabled: state.loading.pricing, children: state.loading.pricing ? 'Saving...' : 'Save' })] })] })] });
                    } }) })] });
};
